import { api } from './client'

/**
 * C-08 (REQ-260-001, 261-001, 262-001): visione motivata dei dati sensibili (`POST /api/sensitive/reveal`, dietro
 * `privacy.mascheramento`). Non restituisce dati: concede per 15 minuti la vista intera di QUELLA scheda a chi la chiede
 * e la scrive in audit con il motivo; la pagina poi rilegge la scheda.
 */
export type SensitiveEntityType =
  | 'people' | 'companies' | 'customers' | 'contacts' | 'supply-points' | 'agents' | 'contracts' | 'leads'

export interface SensitiveRevealResponse {
  entityType: SensitiveEntityType
  entityId: number
  fullView: boolean
  expiresAt: string | null
}

export const sensitiveApi = {
  reveal: (entityType: SensitiveEntityType, entityId: number, reason: string) =>
    api<SensitiveRevealResponse>('/api/sensitive/reveal', {
      method: 'POST',
      body: JSON.stringify({ entityType, entityId, reason }),
    }),
}

/** Vero se il valore arriva mascherato dal server (contiene un asterisco). */
export function isMasked(value: string | null | undefined): boolean {
  return typeof value === 'string' && value.includes('*')
}
